var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.popupId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myLargeModalLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h2", [_vm._v("RELAUNCH | PICKL Optimization Program")]),
              _c("button", {
                ref: "popupCloseButton",
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                }
              })
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _vm.step == 1
                ? _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: {
                        border: "1px solid #BDA340",
                        padding: "2%"
                      }
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "margin-left": "1%",
                            "text-align": "center",
                            color: "black"
                          }
                        },
                        [_vm._v("How would you like to re-launch the tasks? ")]
                      )
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "row" }, [
                _c("br"),
                _c("button", {
                  staticClass: "pull-right  btn-positive",
                  attrs: { disabled: _vm.submittingForm },
                  domProps: { innerHTML: _vm._s(_vm.relaunchButtonLabel) },
                  on: { click: _vm.relaunchSelectedPickls }
                })
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }